var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from 'react';
import { pick } from 'ramda';
import { TableSpinner } from '../TableSpinner';
import CardHeader from './CardHeader';
import CardData from './CardData';
import { StyledTableCard } from './shared';
import { useFocus } from '../../tools/utils';
import { getPublicRowStateProps, TableCellProvider, useDrawer, } from '../utils';
var CardBody = function (_a) {
    var isLoading = _a.isLoading, row = _a.row, drawerProps = _a.drawerProps, cellDrawerProps = _a.cellDrawerProps, cardDataProps = __rest(_a, ["isLoading", "row", "drawerProps", "cellDrawerProps"]);
    if (isLoading) {
        return React.createElement(TableSpinner, null);
    }
    return (React.createElement(CardData, __assign({ row: row, drawerProps: drawerProps, cellDrawerProps: cellDrawerProps }, cardDataProps)));
};
var Card = function (_a) {
    var row = _a.row, mdDownHeaderDetail = _a.mdDownHeaderDetail, cardIsFocused = _a.cardIsFocused, isLoading = _a.isLoading, index = _a.index, cardDataProps = __rest(_a, ["row", "mdDownHeaderDetail", "cardIsFocused", "isLoading", "index"]);
    var _b = __read(useFocus(), 2), focusRef = _b[0], setFocus = _b[1];
    useEffect(function () {
        if (cardIsFocused) {
            setFocus();
        }
    }, [cardIsFocused, setFocus]);
    var drawerProps = useDrawer(row);
    var cellDrawerProps = pick(['isDrawerOpen', 'toggleDrawer', 'drawerTriggerRef'], drawerProps);
    var tableCellContext = __assign(__assign(__assign({}, cellDrawerProps), getPublicRowStateProps(row)), { data: row.original });
    var hideCard = isLoading && index !== 0;
    if (hideCard)
        return null;
    return (React.createElement(StyledTableCard, { ref: focusRef, tabIndex: -1 },
        React.createElement(TableCellProvider, { value: tableCellContext },
            React.createElement(CardHeader, { row: row, mdDownHeaderDetail: mdDownHeaderDetail, cellDrawerProps: cellDrawerProps, isLoading: isLoading }),
            React.createElement(CardBody, __assign({ isLoading: isLoading, row: row, drawerProps: drawerProps, cellDrawerProps: cellDrawerProps }, cardDataProps)))));
};
export default Card;
//# sourceMappingURL=Card.js.map